<body style="background-color: #3f51b5;">
    <mat-card>
        <mat-card-title>اعادة تعيين كلمة السر</mat-card-title>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="submit()">

                <p>
                    <mat-form-field appearance="standard">
                        <input type="text" matInput placeholder="{{'userName' | translate}}" formControlName="username">
                    </mat-form-field>
                </p>

                <p *ngIf="error" class="error">
                    {{ error }}
                </p>

                <div class="button text-center">
                    <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">
                        {{'send' | translate}}</button>
                    &nbsp;
                    <button type="button" mat-raised-button (click)="onBack()">{{'back' | translate}}</button>
                </div>



            </form>
        </mat-card-content>
    </mat-card>

    <app-matspinner [overlay]="spinnerOverlay"></app-matspinner>
</body>